document.addEventListener("DOMContentLoaded", function () {
  // Sabhi text nodes ko check karo jo "Length" likhe hue hain
  document.querySelectorAll("*").forEach(function (el) {
    if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
      if (el.textContent.trim() === "Length") {
        el.textContent = "Length (Inches)"; // ← Change here
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const prices = document.querySelectorAll(".price-item");

  prices.forEach(function (priceElement) {
    const text = priceElement.textContent.trim();

    // Match price formats like: Rs. 13,199.00 or ₹13,199.00
    const updated = text.replace(/(\d+),?(\d+)\.00\b/, "$1,$2");

    // Replace only if it has .00
    if (updated !== text) {
      priceElement.textContent = updated;
    }
  });
});





